// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YslThCyYAVAYJpJGPMVM {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mRPiz89uKM6a4Guo9PsA {
    background-color: #FF6B78;
    color: white;
    font-size: x-small;
    margin-left: 5px;
}

.b61ZGnhRraErRG7WcsaM {
    background-color: rgb(182, 182, 182);
    color: rgb(102, 102, 102);
    font-size: x-small;
}

.mRPiz89uKM6a4Guo9PsA:hover {
    color: white;
    cursor: default;
    text-decoration: none;
}

.vCN26wVeslNlrRTQjaqE {
    background-color: #f5fbfc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-table/table.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".content {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.skipContainer {\n    background-color: #FF6B78;\n    color: white;\n    font-size: x-small;\n    margin-left: 5px;\n}\n\n.subsidyPill {\n    background-color: rgb(182, 182, 182);\n    color: rgb(102, 102, 102);\n    font-size: x-small;\n}\n\n.skipContainer:hover {\n    color: white;\n    cursor: default;\n    text-decoration: none;\n}\n\n.highlightedRow {\n    background-color: #f5fbfc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `YslThCyYAVAYJpJGPMVM`,
	"skipContainer": `mRPiz89uKM6a4Guo9PsA`,
	"subsidyPill": `b61ZGnhRraErRG7WcsaM`,
	"highlightedRow": `vCN26wVeslNlrRTQjaqE`
};
export default ___CSS_LOADER_EXPORT___;
